import { createReducer, on } from '@ngrx/store';
import { QuizProgress } from '../models';
import { quizProgressActions } from '../actions/quiz-progress.actions';

export interface QuizProgressState {
    quizId: string | null;
    progress: QuizProgress | null;
    loading: boolean;
    loaded: boolean | null;
    saving: boolean;
    saved: boolean | null;
    retrying: boolean;
}

const initialState: QuizProgressState = {
    quizId: null,
    progress: null,
    loading: false,
    loaded: null,
    saving: false,
    retrying: false,
    saved: null,
};

export const quizProgressReducer = createReducer(
    initialState,

    // Get Progress
    on(
        quizProgressActions.getProgress,
        (state, { quizId }): QuizProgressState => ({
            ...initialState,
            quizId,
            loading: true,
        }),
    ),
    on(
        quizProgressActions.getProgressSuccess,
        (state, { payload }): QuizProgressState => ({
            ...state,
            progress: payload,
            loading: false,
            loaded: true,
        }),
    ),
    on(
        quizProgressActions.getProgressNotStarted,
        (state): QuizProgressState => ({
            ...state,
            progress: null,
            loading: false,
            loaded: true,
        }),
    ),
    on(
        quizProgressActions.getProgressError,
        (state): QuizProgressState => ({
            ...state,
            loading: false,
            loaded: false,
        }),
    ),

    // Save Answer
    on(
        quizProgressActions.saveAnswer,
        (state): QuizProgressState => ({
            ...state,
            saving: true,
            saved: null,
        }),
    ),
    on(
        quizProgressActions.saveAnswerSuccess,
        (state, { payload }): QuizProgressState => ({
            ...state,
            progress: payload,
            loaded: true,
            saving: false,
            saved: true,
        }),
    ),
    on(
        quizProgressActions.saveAnswerError,
        (state): QuizProgressState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    on(
        quizProgressActions.clearSaved,
        (state): QuizProgressState => ({
            ...state,
            saved: null,
        }),
    ),

    // Retry
    on(
        quizProgressActions.retry,
        (state): QuizProgressState => ({
            ...state,
            retrying: true,
        }),
    ),
    on(
        quizProgressActions.retrySuccess,
        (): QuizProgressState => ({
            ...initialState,
        }),
    ),
    on(
        quizProgressActions.retryError,
        (state): QuizProgressState => ({
            ...state,
            retrying: false,
        }),
    ),

    // Clear
    on(quizProgressActions.clear, (): QuizProgressState => ({ ...initialState })),
);
